import { useState } from 'react'
import { useStyletron, withStyle } from 'baseui'
import { useTranslation } from 'react-i18next'
import { StyledBodyCell } from 'baseui/table-grid'

const useRowsRequestTable = ({ id, isSentRequest }) => {
  const [css] = useStyletron()
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState(false)
  const CenteredBodyCell = withStyle(StyledBodyCell, {
    display: 'flex',
    alignItems: 'center',
  })

  const requestType = isSentRequest ? 'SENT' : 'RESPONSE'
  const downloadFileName = id + '-' + requestType

  const directionText = () => {
    return isSentRequest
      ? t('subscriptionForm:subscription_actions_module.export_logs.direction_sent')
      : t('subscriptionForm:subscription_actions_module.export_logs.direction_receive')
  }

  const addZero = number => {
    return number < 10 ? `0${number}` : number
  }

  const formatDate = date => {
    const dateObject = new Date(date)
    return `${addZero(dateObject.getDate())}-${addZero(dateObject.getMonth() + 1)}-${dateObject.getFullYear()} ${dateObject.getHours()}:${dateObject.getMinutes()}:${dateObject.getSeconds()}`
  }

  const downloadJSON = (jsonData, downloadFileName) => {
    const jsonText = JSON.stringify(jsonData, null, 2)
    const blob = new Blob([jsonText], { type: 'text/plain' })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = downloadFileName + '.json'
    a.click()
    window.URL.revokeObjectURL(url)
  }
  const toggleExpand = idx => {
    setExpanded(prev => (prev === idx ? false : idx))
  }

  return {
    css,
    t,
    CenteredBodyCell,
    expanded,
    toggleExpand,
    downloadFileName,
    directionText,
    formatDate,
    downloadJSON,
  }
}

export default useRowsRequestTable
